/**
 * Labstep
 *
 * @module components/ExperimentWorkflowLink/List
 * @desc List of ExperimentWorkflowLinks
 */

import { EntityDraggable } from 'labstep-web/components/Entity/Draggable';
import { ExperimentWorkflowLinkItem } from 'labstep-web/components/ExperimentWorkflowLink/Item';
import { List } from 'labstep-web/core/List';
import type React from 'react';
import type { ExperimentWorkflowLinkListProps } from './types';

export const ExperimentWorkflowLinkList: React.FC<
  ExperimentWorkflowLinkListProps
> = ({ experimentWorkflowLinks, showBackLinks }) => (
  <List id="experiment-workflow-link-list">
    {experimentWorkflowLinks.map((experimentWorkflowLink) => {
      const item = (
        <ExperimentWorkflowLinkItem
          key={experimentWorkflowLink.guid}
          experimentWorkflowLink={experimentWorkflowLink}
          showBackLinks={showBackLinks}
        />
      );
      return showBackLinks ? (
        item
      ) : (
        <EntityDraggable
          key={experimentWorkflowLink.guid}
          entityGuid={experimentWorkflowLink.guid}
          entityName={experimentWorkflowLink.entityName}
          children={item}
        />
      );
    })}
  </List>
);
